import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./pdf-viewer.style.css";

function PdfViewer({ pdfUrl, fileName, onClose }) {
  const { t } = useTranslation();

  // Add #toolbar=0 to hide PDF toolbar for better display
  const directPdfUrl = `${pdfUrl}#toolbar=0`;

  const handleOpenInNewTab = (e) => {
    e.stopPropagation();
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pdf-viewer-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="pdf-viewer-title">
      <div className="pdf-viewer-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <header className="pdf-viewer-header">
          <h3 id="pdf-viewer-title" className="pdf-viewer-title">{fileName}</h3>
          <button
            type="button"
            className="btn btn-close pdf-viewer-close"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </header>

        {/* Content */}
        <div className="pdf-viewer-content">
          <object
            data={directPdfUrl}
            type="application/pdf"
            className="pdf-viewer-iframe"
            aria-label={t('documents.pdfPreview')}
          >
            <embed
              src={directPdfUrl}
              type="application/pdf"
              className="pdf-viewer-iframe"
            />
            <div className="pdf-fallback">
              <p className="fallback-message">{t('documents.pdfNotSupported')}</p>
              <p className="fallback-hint">{t('documents.useButtonsBelow')}</p>
            </div>
          </object>
        </div>

        {/* Footer with actions */}
        <footer className="pdf-viewer-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleOpenInNewTab}
            aria-label={t('documents.openInNewTab')}
          >
            {t('documents.openInNewTab')}
          </button>
          <a
            href={pdfUrl}
            download={fileName}
            className="btn btn-accept"
            onClick={(e) => e.stopPropagation()}
            aria-label={t('common.download')}
          >
            {t('common.download')}
          </a>
        </footer>
      </div>
    </div>
  );
}

PdfViewer.propTypes = {
  pdfUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PdfViewer;


